module.exports = __webpack_public_path__ + "static/media/c51.bd852c73.png";